import { http } from '@/services/http_service';
export default{
    uploadImage(context, data)
    {
        //앞단에서 받아서 판별이 필요하기 때문에 return
        return http()
        .post("/upload/image", data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data);
            return response.data;
        },function(error){
            console.log(error.response.data);
        });
    },
}
